<template>
    <div > 
    <el-tabs :animated="false" style="background:white" v-model="active">
        <el-tab-pane name="first">
            <span slot="label"><i class="iconfont icon-yonghu-yuan"></i> 客户资料</span>    
            <div style=" display:flex; width:100%; background:#f8f8f9;line-height:40px;height:40px;  border-left:3px solid #409eff">
                <div style="min-width:1100px;display:flex">
                    <el-select v-model="selparam"  placeholder="请选择列名" clearable size="small" style="width:150px;margin-left:20px; ">
                        <span v-for="item in tabArr" :key='item.key'>
                            <el-option :label="item.title" :value="item.key"></el-option>
                        </span>
                    </el-select>
                    <el-select v-model="oper"  size="small" style="width:110px;margin-bottom:3px;margin-left:2px; ">
                        <el-option label="等于" value="="></el-option>
                        <el-option label="相似于" value="like"></el-option>
                        <el-option label="大于等于" value="&ge;"></el-option>
                        <el-option label="小于等于" value="&le;"></el-option>
                    </el-select>
                    <el-input placeholder="请输入查询值" v-model="txtparam" size="small" style="width:200px;margin-left:2px;margin-top:3px; ">
                        <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                    </el-input> 
                    <el-button size="mini" icon="iconfont icon-chenggong1" @click="selSure" style="color:#409eff;margin-left:30px;height:35px;margin-top:3px;">确定选择</el-button>
                </div>
            </div> 
            <el-table  :data="tabData" 
                    border                            
                    disabled-hover
                    style="overflow:auto;margin-top:1px;"
                    size="small"
                    :height="tabHeight" 
                    :row-key="getRowKey"  
                    ref="tabref" 
                    @row-click="rowClick"
                    @row-dblclick="selSure"
                    highlight-current-row>
                <span v-for="(item,index ) in tabArr" :key="index">
                    <el-table-column  v-if="item.thide==='N'&&item.key!=='STFG'"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"    
                        :fixed="item.key==='IDNO'"                              
                        sortable
                        :min-width="item.width">
                    </el-table-column> 
                    <el-table-column  v-if="item.key==='STFG'"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :min-width="item.width">
                        <template   slot-scope="scope" >
                            <i v-if="scope.row.STFG==='Y'" class="iconfont icon-xuanze" style="color:green"></i>
                            <i v-if="scope.row.STFG==='N'" class="iconfont icon-xuanze"  ></i>
                            <i v-if="scope.row.STFG==='X'" class="iconfont icon-xuanze" style="color:red"></i>
                        </template>
                    </el-table-column>
                </span>
                
            </el-table>  
        </el-tab-pane>
 
    </el-tabs>
 
    <!-- 提示框 -->
    <el-dialog  :visible.sync="promtWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
        <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
            <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
        </div>
        <span>{{prompt}}</span>
        <span slot="footer"  >
            <el-button type="primary" size="small" @click="promtWin = false">确 定</el-button>
        </span>
    </el-dialog>
 
    </div>  
</template>
<script>
 
import { getTabColOrData,getBaseData } from '../../api/user';
 
//局部注册
export default {
    data () {
        return {
            promtWin:false,
            prompt:'',
            custRow:{},
            supRow:{},
            active: 'first',
            supData:[],    
       
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
 
            tabData:[], //表数据
            allData:[],
            tabArr:[], //表列
            supArr:[],
            oper:'like',
            txtparam:'',
            selparam:'',
            txtparam2:'',
            selparam2:'',
            oper2:'like',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            dataCount:0,
            rowSize:20,
            current:1,
 
        }
    },
    mounted () { 
 
 
    },
    computed: {
        editHeight: function() {
            return (window.innerHeight - 300) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 200) + 'px';
        }, 
    },
    components: {
     
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            this.getClntList('')
            this.getSupList('')
            this.getTabField() //表列字段
 
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        //表行点击事件
        rowClick(row){
            this.custRow=row            
        },
        rowSup(row){
            this.supRow=row            
        },
        selSure(){
            if (this.custRow['CLNTNM']){
                this.$emit('child-clnt',this.custRow['IDSEQ'],this.custRow['CLNTNM'])
                this.$emit('child-clntobj',{CLNTNO:this.custRow['IDSEQ'],CLNTNM:this.custRow['CLNTNM'],CRCY:this.custRow['CRCY'],CRCYNM:this.custRow['CRCYNM']})
            }else{
                this.promtWin=true
                this.prompt='请选择一客户记录'
            }
        },
        selSup(){
            if (this.supRow['SUPNM']){
                this.$emit('child-sup',this.supRow['IDSEQ'],this.supRow['SUPNM'])
                this.$emit('child-supobj',{SUPNO:this.custRow['IDSEQ'],SUPNM:this.custRow['CLNTNM'],CRCY:this.custRow['CRCY'],CRCYNM:this.custRow['CRCYNM']})
            }else{
                this.promtWin=true
                this.prompt='请选择一供应商记录'
            }
        },
        //客户明细
        getClntList(cond){
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'', p_value:'',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond,p_table:'V_BS_CLNT'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.allData =res.result
                    this.initPage() 
                }else{
                    this.promtWin=true
                    this.prompt=res.result
                }
 
            }) 
        },
        //供应商明细
        getSupList(cond){
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'', p_value:'',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond,p_table:'v_bs_sup'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.supData =res.result
                }else{
                    this.promtWin=true
                    this.prompt=res.result
                }
  
            }) 
        },
        //初始化查询页条数
        initPage(){
            //产品明细
           // this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
           // if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            // }else{
            //     this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
            // }
        },
 
        getRowKey(row){
            return row.IDSEQ
        },
        //查询
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and '+this.selparam+' like \'%' + this.txtparam+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam +this.oper+'\''+this.txtparam+'\''
                }
            }
            this.getClntList(  cond_)
        },
        //供应商查询
        qrySupData(){
            let cond_=''
            if (this.selparam2){ //列1
                if (this.oper2==='like'){
                    cond_=cond_+' and '+this.selparam2+' like \'%' + this.txtparam2+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam2 +this.oper2+'\''+this.txtparam2+'\''
                }
            }
            this.getSupList(  cond_)
        },
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','94','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','100','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.supArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            });
 
        }
    }
}
</script>
<style scoped lang="less">
    .el-aside {
        height: calc(100vh - 100px);// vh就是当前屏幕可见高度的1%   只用设置左侧 aside 高度
    }
    .oneMenu{
        line-height:35px;
        text-align:left;
        padding-left:35px;
        font-size:14px;
        color:white;
        background-color: #409eff;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#f4f6f8;
    }
    .twoMenu{
        display:flex;
        flex-direction:column;
        line-height:40px;
        background:white;
        padding-left:35px;
 
    }
    .twoMenu:hover{
        cursor: pointer;
        color:#409EFF;
    }
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
    .el-header  {
        background-color: #fff;
        color: #409EFF;
        text-align: center;
        line-height: 60px;
        width:100%;
    }
  .el-main {
    background-color: #fff;
    color: rgb(207, 206, 206);
    text-align: center;
    height:100%;
  }
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
    .active { 
        color:#D200D2; 
    } 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
<style lang="less">
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    // .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
 